<template>
  <div v-show="visibility" class="row -grid-cell-component">
    <div ref="parentTextInput" class="col-sm-9" />
    <div class="col-sm-3">
      <span v-show="showSeparator">/</span><span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CellTextField from '~common/components/gridCell/CellTextField/CellTextFieldView';

export default {
  name: 'CellTextFieldWithLabel',

  props: {
    checkEditableFunction: {
      type: Function,
      default: null,
    },
    checkDisabledFunction: {
      type: Function,
      default: null,
    },
    checkVisibilityFunction: {
      type: Function,
      default: null,
    },
    textFieldProps: {
      type: Object,
      default: null,
    },
    fdpTextValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    showSeparator: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      editable: true,
      disabled: false,
      visibility: true,
      text: this.label,
    };
  },
  mounted() {
    this.createdTextField();
  },
  beforeDestroy() {
    if (this.textField) {
      this.textField.$off('keyup', this.fdpTextKeyup);
      this.textField.$off('input', this.fdpTextInput);
      this.textField.$off('blur', this.fdpTextBlur);
      this.textField.$off('focus', this.fdpTextFocus);
      this.textField.$destroy();
    }
    this.handleBeforeDestroy();
  },
  methods: {
    setVisibility(rowData, columnName, dataset, grid) {
      if (this.checkVisibilityFunction) {
        this.visibility = this.checkVisibilityFunction(rowData, columnName, dataset, grid);
      }
    },
    handleBeforeDestroy() {
      (this.$el && this.$el.parentNode) ? this.$el.parentNode.removeChild(this.$el) : '';
    },
    fdpTextKeyup() {
      this.$emit('keyup');
    },
    fdpTextInput() {
      this.$emit('input');
    },
    fdpTextBlur() {
      this.$emit('blur');
    },
    fdpTextFocus() {
      this.$emit('focus');
    },
    createdTextField() {
      console.log(Vue);
      const ComponentClass = Vue.extend(CellTextField);

      this.textFieldProps.value = this.fdpTextValue;
      this.textFieldProps.checkEditableFunction = this.checkEditableFunction;
      this.textFieldProps.checkDisabledFunction = this.checkDisabledFunction;

      this.textField = new ComponentClass({
        propsData: this.textFieldProps,
      });

      this.textField.$mount();
      this.$refs.parentTextInput.appendChild(this.textField.$el);

      // event연결
      this.textField.$on('keyup', this.fdpTextKeyup);
      this.textField.$on('input', this.fdpTextInput);
      this.textField.$on('blur', this.fdpTextBlur);
      this.textField.$on('focus', this.fdpTextFocus);

      this.$emit('initialized');
    },
    setLabel(label) {
      this.text = label;
    },
    setEditable(dataRow, columnName, dataset, grid) {
      if (this.textField) {
        this.textField.setEditable(dataRow, columnName, dataset, grid);
      }
    },
    setDisabled(dataRow, columnName, dataset, grid) {
      if (this.textField) {
        this.textField.setDisabled(dataRow, columnName, dataset, grid);
      }
    },
    setValue(value) {
      this.setLabel(value.label);
      if (this.textField) {
        this.textField.setValue(value.inputText);
      }
    },
    activate() {
      if (this.textField) {
        this.textField.setFocus();
      }
    },
    setFocus() {
      this.activate();
    },
  },
};
</script>

<style>
</style>
